import { useEffect, useState } from 'react';

import { generateMediaQuery, QueryOptions } from './generateMediaQuery';
import { MediaQueryCache } from './MediaQueryCache';
import { Breakpoint } from './constants';

export const useMediaQuery = (breakpoint: Breakpoint, options: QueryOptions = {}) => {
  const cacheKey = `${breakpoint}_${JSON.stringify(options)}`;

  let mediaQuery = MediaQueryCache.get(cacheKey);

  if (!mediaQuery) {
    const mediaQueryString = generateMediaQuery(breakpoint, options);

    // for SSR apps
    if (typeof window === 'undefined') {
      mediaQuery = {
        matches: false,
        media: mediaQueryString,
      } as MediaQueryList;
    } else {
      mediaQuery = window.matchMedia(mediaQueryString);
    }

    MediaQueryCache.set(cacheKey, mediaQuery);
  }

  const [isMediaQueryMatching, setIsMediaQueryMatching] = useState(mediaQuery.matches);

  useEffect(() => {
    const handler = (event: MediaQueryListEvent) => setIsMediaQueryMatching(event.matches);

    mediaQuery?.addListener(handler);

    return () => mediaQuery?.removeListener(handler);
  }, [mediaQuery]);

  return isMediaQueryMatching;
};
